import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=2cc42db0&scoped=true&"
import script from "./recycleBin.vue?vue&type=script&lang=js&"
export * from "./recycleBin.vue?vue&type=script&lang=js&"
import style0 from "./recycleBin.vue?vue&type=style&index=0&id=2cc42db0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc42db0",
  null
  
)

export default component.exports